import { Location } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-navigate-back',
  standalone: true,
  imports: [],
  templateUrl: './navigate-back.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./navigate-back.component.scss']
})
export class NavigateBackComponent {

  constructor(public location: Location) { }

  navigateBack() {
    this.location.back();
  }
}
